// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hV7l","inner":"Footer_inner__3OAaS","nextIcon":"Footer_nextIcon__3Gmch","innerLeft":"Footer_innerLeft__2L7eL"};